<div class="toolbar-user" (prepClickOutside)="onClickOutside()" fxFlex="grow">
  <!-- Toggle Button for User Menu -->
  <button id="user-menu-button" class="button" mat-button (click)="toggleDropdown()" [class.open]="isOpen" fxFlex="grow"
    aria-label="User menu" [matTooltip]="LangTextData.tooltipLabel.toolBoxUserProfile"
    matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below" aria-haspopup="true"
    [attr.aria-expanded]="isOpen" aria-controls="user-menu" type="button" >
    <span fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="list-item-icon" aria-hidden="true">account_circle</mat-icon>
    </span>
  </button>
  <!-- Dropdown Menu -->
  <div *ngIf="isOpen" class="dropdown" [class.open]="isOpen" id="user-menu" role="menu" aria-label="User dropdown menu"
     (focusout)="onFocusOut($event)">
    <div class="content">
      <div class="list">
        <!-- Profile Menu Item -->
        <div class="list-item" matRipple role="menuitem" tabindex="0" (click)="profile()" (keydown.enter)="profile()"
          (keydown.space)="profile()" aria-label="View profile">
          <mat-icon class="list-item-icon" aria-hidden="true">account_circle</mat-icon>
          <span> {{LangTextData?.htmlLabel.userProfileText}}</span>
        </div>
        <mat-divider></mat-divider>
        <!-- Logout Menu Item -->
        <div class="list-item" matRipple role="menuitem" tabindex="0" (click)="logoutClicked()"
          (keydown.enter)="logoutClicked()" (keydown.space)="logoutClicked()" aria-label="Log out">
          <mat-icon class="list-item-icon" aria-hidden="true">exit_to_app</mat-icon>
          <span> {{LangTextData?.htmlLabel.userProfileLogoutText}}</span>
        </div>

      </div>
    </div>
  </div>
</div>